import { render } from "./ClinicsManager.vue?vue&type=template&id=60a57ef8&scoped=true"
import script from "./ClinicsManager.vue?vue&type=script&lang=js"
export * from "./ClinicsManager.vue?vue&type=script&lang=js"

import "./ClinicsManager.vue?vue&type=style&index=0&id=60a57ef8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a57ef8"]])

export default __exports__